"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _themeColors$general;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccDateTimePickerStyle = (0, _react.useMemo)(function () {
    var deviceDateTimePickerProps = function deviceDateTimePickerProps() {
      var display = isMobileView ? 'block' : 'inline-block';
      var borderRadius = isMobileView ? pxToRem(6) : pxToRem(25);
      return {
        display: display,
        borderRadius: borderRadius
      };
    };
    var deviceTimeProps = function deviceTimeProps() {
      var width = isMobileView ? pxToRem(316) : 'auto';
      var margin = isMobileView ? '0 auto' : 'auto';
      return {
        width: width,
        margin: margin
      };
    };
    var deviceTitleProps = function deviceTitleProps() {
      var fontSize = basicFontSize;
      var fontWeight = 'bold';
      var marginBottom = isMobileView ? 0 : pxToRem(3);
      return {
        fontSize: fontSize,
        fontWeight: fontWeight,
        marginBottom: marginBottom
      };
    };
    var ccDateTimePicker = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily
    }, deviceDateTimePickerProps()));
    var ccDateTimePickerAnchorBtn = (0, _css.css)({
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridAutoColumns: '1fr',
      gridAutoFlow: 'column',
      gridTemplateRows: '1fr',
      alignItems: 'center',
      justifyItems: 'center',
      alignContent: 'center',
      justifyContent: 'space-around',
      gap: '1rem',
      direction: 'ltr',
      lineHeight: 1,
      width: '100%',
      height: pxToRem(36),
      '& > *': {
        '& > div:nth-child(2)': {
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText,
          whiteSpace: 'nowrap',
          lineHeight: 0.8
        }
      }
    });
    var ccDateTimePickerDateTitle = (0, _css.css)(_objectSpread({}, deviceTitleProps()));
    var ccDateTimePickerTime = (0, _css.css)(_objectSpread({
      marginBottom: pxToRem(3),
      marginInlineStart: pxToRem(3)
    }, deviceTimeProps()));
    var ccDateTimePickerTimeTitle = (0, _css.css)(_objectSpread({
      marginInlineStart: pxToRem(11)
    }, deviceTitleProps()));
    return {
      ccDateTimePicker: ccDateTimePicker,
      ccDateTimePickerAnchorBtn: ccDateTimePickerAnchorBtn,
      ccDateTimePickerDateTitle: ccDateTimePickerDateTitle,
      ccDateTimePickerTime: ccDateTimePickerTime,
      ccDateTimePickerTimeTitle: ccDateTimePickerTimeTitle
    };
  }, [basicFontSize, fontFamily, isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : (_themeColors$general = themeColors.general) === null || _themeColors$general === void 0 ? void 0 : _themeColors$general.subText]);
  return {
    'cc-DateTimePicker': ccDateTimePickerStyle.ccDateTimePicker,
    'cc-DateTimePicker__anchor-btn': ccDateTimePickerStyle.ccDateTimePickerAnchorBtn,
    'cc-DateTimePicker__date-title': ccDateTimePickerStyle.ccDateTimePickerDateTitle,
    'cc-DateTimePicker__time': ccDateTimePickerStyle.ccDateTimePickerTime,
    'cc-DateTimePicker__time-title': ccDateTimePickerStyle.ccDateTimePickerTimeTitle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;